import _ from 'lodash';
import { useEffect } from 'react';
import { connect } from 'react-redux';

/**
 * Higher Level component to get country code from Redux.
 */
export default function withCountryCode(Component) {
  const mapStateToProps = (state, ownProps) => ({
    countryCode: _.get(state, 'common.country'),
    ...ownProps,
  });

  return connect(mapStateToProps)(Component);
}

/**
 * 
 * Higher level component to get state and country code from Redux.
 */
export function withLocation(Component) {
  const mapStateToProps = (state, ownProps) => ({
    countryCode: _.get(state, 'common.country'),
    stateCode: _.get(state, 'common.state'),
    ...ownProps,
  });

  return connect(mapStateToProps)(Component);
}

/**
 * Helper to define a default way of extracting values from an object using a country code.
 * @param {String} key A key for the default string in the hash object
 * @param {String} countryCode Appended to key to build a country specific key
 * @param {Object} hash Object of anything
 */
export function getValueFromCountryCode(key, countryCode, hash) {
  let value = hash[`${key}-${countryCode}`];
  if (!value) {
    value = hash[key];
  }
  return value;
}

/**
 * Helper for sending information to analytics locations
 * @param {String} countryCode Shortened representation of country name
 * @param {String} stateCode Shortened representation of region name in country
 * @returns 
 */
function sendAnalytics(countryCode, stateCode) {
  // for segment tracking
  window.analytics.page('', '', {
    countryCode: countryCode,
    stateCode: stateCode,
  });

  // For GTM
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    countryCode,
    stateCode,
  });
}

/**
 * Helper to extract and send state code where it needs to go
 */
function identifyGeo({countryCode, stateCode}) {
    useEffect(() => {
      if (typeof window !== 'undefined') {
        if (!countryCode || !stateCode) {
          fetch('/dotcom/api/geolocation')
          .then(result => result.json())
          .then(data => {
            sendAnalytics(data.country, data.state);
          })
          .catch(err => {
            sendAnalytics('US', 'unknown');
          });
        } else {
          sendAnalytics(countryCode, stateCode);
        }
      }
    }, []);
  return null;
};

export const IdentifyGeo = withLocation(identifyGeo);



// WEBPACK FOOTER //
// ./app/common/containers/country-code.js